import { TextField, TextFieldProps } from '@mui/material'

const TextComponent = ({ ...props }: TextFieldProps) => (
  <TextField
    {...props}
    size="small"
    slotProps={{
      ...props.slotProps,
      inputLabel: { shrink: true }
    }}
  />
)

export default TextComponent
